<template>
  <banner-menu :value="stores" :height="height" :loading="loading" :essential="essential">
    <div v-for="item in stores" :key="item.id" :slot="item.title">
      <span v-html="item.content" />
    </div>
  </banner-menu>
</template>

<script>
import BannerMenu from '@/components/BannerMenu'

export default {
  name: 'stores',
  components: { BannerMenu },
  props: {
    language: String,
    height: { type: Number, default: 600 }
  },
  data: () => ({
    stores: [
      {
        id: 1,
        title: 'Optik Pillwein',
        slug: 'head',
        url: '/stores/head',
        content: '<h2>Headquarter</h2><p>Kohlmarkt 16<br>1010 Wien<br>+43 1 533 94 50<br><a href="mailto:optikpillwein@aon.at">optikpillwein@aon.at</a></p>',
        map: 'https://www.google.at/maps/place/OPTIK+PILLWEIN/@48.2084236,16.3648183,17z/data=!3m1!4b1!4m5!3m4!1s0x476d0799ad4b1607:0x4dced091d462e24f!8m2!3d48.20842!4d16.367007',
        source: [{ id: 10, source: '/img/stores/Head.jpg' }]
      },
      {
        id: 2,
        title: 'Optik Pillwein Lounge',
        slug: 'lounge',
        url: '/stores/lounge',
        content: '<h2>Lounge</h2><p>Obkirchergasse 15<br>1190 Wien<br>+43 1 369 50 25<br><a href="mailto:pillweinlounge@aon.at">pillweinlounge@aon.at</a></p>',
        map: 'https://www.google.at/maps/place/OPTIK+PILLWEIN+Lounge/@48.2420897,16.3390664,17z/data=!3m1!4b1!4m5!3m4!1s0x476d0629da4eb4d5:0xbdfc5cb599617c2e!8m2!3d48.2420861!4d16.3412551',
        source: [{ id: 1, source: '/img/stores/Lounge.jpg' }]
      },
      {
        id: 3,
        title: 'Optik Pillwein Atelier',
        slug: 'atelier',
        url: '/stores/atelier',
        content: '<h2>Atelier</h2><p>Köstlergasse 11<br>Ecke Gumpendorferstraße<br>1060 Wien<br>+43 1 585 02 37<br><a href="mailto:pillweinatelier@a1.net">pillweinatelier@a1.net</a></p>',
        map: 'https://www.google.at/maps/place/OPTIK+PILLWEIN+Atelier/@48.1987817,16.3564836,17z/data=!3m1!4b1!4m5!3m4!1s0x476d078588659237:0x750e664f6eb744cd!8m2!3d48.1987781!4d16.3586724',
        source: [{ id: 6, source: '/img/stores/Atelier.jpg' }]
      }
    ],
    loading: false,
    essential: true
  })
}
</script>
